import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { initErrorHandler } from './utils/errorHandler'

Vue.use(Vant)

Vue.config.productionTip = false

// 初始化全局错误处理
initErrorHandler(Vue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
